/* eslint-disable camelcase */
import { isNil, omitBy } from 'lodash';

export const getSharedData = ({ data }) => {
    const { loggedUser, objectSelected } = data || {};
    const { team_id: teamId } = loggedUser?.company || {};
    const { id: clientId } = objectSelected?.client_selected || {};
    const { id: accountId } = objectSelected?.account_selected || {};

    const accountSelected = data?.objectSelected?.isAccountSelected;
    const level = accountSelected ? 'account' : 'client';

    return omitBy({
        accountId,
        clientId,
        teamId,
        level,
    }, isNil);
};
